export default ({ request }) => ({
  pendingGoodsQualityListApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/quality/qualityList',
      method: 'post',
      data
    })
  },
  pendingGoodsQualityDetailApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/quality/qualityDetail',
      method: 'post',
      data
    })
  },
  pendingGoodsQualityGroupApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/quality/qualityGroup',
      method: 'post',
      data
    })
  },
  pendingGoodsQualityEditApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/quality/edit',
      method: 'post',
      data
    })
  },
  pendingGoodsQualityChangeGoodsApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/quality/changeGoods',
      method: 'post',
      data
    })
  },
})
